<ng-content select="dtm-ui-expandable-panel"></ng-content>
